import React from 'react'
import { FormSkinProps } from '../types'
import useFormSkinController from './hooks/use-form-skin-controller'
import FormSkin from './form-skin'

type Props = FormSkinProps

/**
 * FormSkinContainer — 将表单皮肤本地交互与旧业务容器回调连接起来。
 * @returns {React.ReactElement} 可直接挂载的表单皮肤
 */
const FormSkinContainer: React.FC<Props> = React.memo(props => {
  const controller = useFormSkinController({
    model: props.model,
    onBack: props.onBack,
    onInvalidIdentity: props.onInvalidIdentity,
    onSubmit: props.onSubmit,
  })

  return <FormSkin {...props} controller={controller} />
})

FormSkinContainer.displayName = 'FormSkinContainer'

export default FormSkinContainer
